import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAbout from "../../components/about/FormAbout";
import { useGetAboutHome } from "../../hooks/about/useGetAboutHome";
import { useUpdateAboutHome } from "../../hooks/about/useUpdateAboutHome";

const AboutHome = () => {
    const { aboutHome, isLoading: isFetching } = useGetAboutHome();
    const { mutate, isPending: isUpdating } = useUpdateAboutHome();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null; // Or insert a loading spinner
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAbout 
                titleAr="من نحن (الرئيسية)" 
                titleEn="About Us (Home)" 
                currentData={aboutHome} 
                onSubmit={handleSubmit} 
                isLoading={isUpdating} 
            />
        </WrapperSection>
    );
};

export default AboutHome;
